import MARKET_LIST from './data/markets.json';
export const MARKETS = MARKET_LIST;
